var _g, _path, _path2, _rect, _rect2, _path3, _path4, _g2, _g3, _g4, _g5, _g6, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPointer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_713_9347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8812 4.52692C14.7411 3.28727 16.477 2.82524 17.7291 3.6384C18.9813 4.45155 19.3239 6.0889 18.5108 7.34106L16.8156 9.95134H27.3455C28.8018 9.95134 29.9824 11.132 29.9824 12.5883C29.9824 14.0447 28.8018 15.2253 27.3455 15.2253H23.0614C23.8534 15.6431 24.3932 16.4746 24.3932 17.4323C24.3932 18.523 23.693 19.4501 22.7177 19.7887C23.2295 20.2837 23.5477 20.9777 23.5477 21.746C23.5477 22.8933 22.8381 23.8749 21.8338 24.2759C22.2412 24.7518 22.4872 25.3699 22.4872 26.0454C22.4872 27.5493 21.268 28.7684 19.7642 28.7684H16.6614C16.6267 28.7684 16.5922 28.7677 16.5578 28.7664H11.6987C10.2674 28.7664 7.8208 27.9182 5.67602 26.2566C5.4558 26.0909 5.24326 25.9153 5.03906 25.7304C5.03498 25.7268 5.0309 25.7232 5.02682 25.7196C5.02677 25.7196 5.02688 25.7195 5.02682 25.7196C3.18038 24.0414 2.01843 21.6019 2.01843 18.8869C2.01843 15.738 3.58174 12.9599 5.96293 11.31C6.79586 10.7067 7.4694 10.4183 8.13863 10.1317C8.65149 9.91201 9.16182 9.69344 9.7394 9.3351C10.6524 8.76863 11.3299 7.93564 11.7085 7.47023C11.7369 7.43522 11.7637 7.40229 11.7888 7.3717L11.7892 7.37396L13.8812 4.52692Z",
    fill: "url(#paint0_radial_713_9347)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8812 4.52692C14.7411 3.28727 16.477 2.82524 17.7291 3.6384C18.9813 4.45155 19.3239 6.0889 18.5108 7.34106L16.8156 9.95134H27.3455C28.8018 9.95134 29.9824 11.132 29.9824 12.5883C29.9824 14.0447 28.8018 15.2253 27.3455 15.2253H23.0614C23.8534 15.6431 24.3932 16.4746 24.3932 17.4323C24.3932 18.523 23.693 19.4501 22.7177 19.7887C23.2295 20.2837 23.5477 20.9777 23.5477 21.746C23.5477 22.8933 22.8381 23.8749 21.8338 24.2759C22.2412 24.7518 22.4872 25.3699 22.4872 26.0454C22.4872 27.5493 21.268 28.7684 19.7642 28.7684H16.6614C16.6267 28.7684 16.5922 28.7677 16.5578 28.7664H11.6987C10.2674 28.7664 7.8208 27.9182 5.67602 26.2566C5.4558 26.0909 5.24326 25.9153 5.03906 25.7304C5.03498 25.7268 5.0309 25.7232 5.02682 25.7196C5.02677 25.7196 5.02688 25.7195 5.02682 25.7196C3.18038 24.0414 2.01843 21.6019 2.01843 18.8869C2.01843 15.738 3.58174 12.9599 5.96293 11.31C6.79586 10.7067 7.4694 10.4183 8.13863 10.1317C8.65149 9.91201 9.16182 9.69344 9.7394 9.3351C10.6524 8.76863 11.3299 7.93564 11.7085 7.47023C11.7369 7.43522 11.7637 7.40229 11.7888 7.3717L11.7892 7.37396L13.8812 4.52692Z",
    fill: "url(#paint1_radial_713_9347)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8812 4.52692C14.7411 3.28727 16.477 2.82524 17.7291 3.6384C18.9813 4.45155 19.3239 6.0889 18.5108 7.34106L16.8156 9.95134H27.3455C28.8018 9.95134 29.9824 11.132 29.9824 12.5883C29.9824 14.0447 28.8018 15.2253 27.3455 15.2253H23.0614C23.8534 15.6431 24.3932 16.4746 24.3932 17.4323C24.3932 18.523 23.693 19.4501 22.7177 19.7887C23.2295 20.2837 23.5477 20.9777 23.5477 21.746C23.5477 22.8933 22.8381 23.8749 21.8338 24.2759C22.2412 24.7518 22.4872 25.3699 22.4872 26.0454C22.4872 27.5493 21.268 28.7684 19.7642 28.7684H16.6614C16.6267 28.7684 16.5922 28.7677 16.5578 28.7664H11.6987C10.2674 28.7664 7.8208 27.9182 5.67602 26.2566C5.4558 26.0909 5.24326 25.9153 5.03906 25.7304C5.03498 25.7268 5.0309 25.7232 5.02682 25.7196C5.02677 25.7196 5.02688 25.7195 5.02682 25.7196C3.18038 24.0414 2.01843 21.6019 2.01843 18.8869C2.01843 15.738 3.58174 12.9599 5.96293 11.31C6.79586 10.7067 7.4694 10.4183 8.13863 10.1317C8.65149 9.91201 9.16182 9.69344 9.7394 9.3351C10.6524 8.76863 11.3299 7.93564 11.7085 7.47023C11.7369 7.43522 11.7637 7.40229 11.7888 7.3717L11.7892 7.37396L13.8812 4.52692Z",
    fill: "url(#paint2_radial_713_9347)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8812 4.52692C14.7411 3.28727 16.477 2.82524 17.7291 3.6384C18.9813 4.45155 19.3239 6.0889 18.5108 7.34106L16.8156 9.95134H27.3455C28.8018 9.95134 29.9824 11.132 29.9824 12.5883C29.9824 14.0447 28.8018 15.2253 27.3455 15.2253H23.0614C23.8534 15.6431 24.3932 16.4746 24.3932 17.4323C24.3932 18.523 23.693 19.4501 22.7177 19.7887C23.2295 20.2837 23.5477 20.9777 23.5477 21.746C23.5477 22.8933 22.8381 23.8749 21.8338 24.2759C22.2412 24.7518 22.4872 25.3699 22.4872 26.0454C22.4872 27.5493 21.268 28.7684 19.7642 28.7684H16.6614C16.6267 28.7684 16.5922 28.7677 16.5578 28.7664H11.6987C10.2674 28.7664 7.8208 27.9182 5.67602 26.2566C5.4558 26.0909 5.24326 25.9153 5.03906 25.7304C5.03498 25.7268 5.0309 25.7232 5.02682 25.7196C5.02677 25.7196 5.02688 25.7195 5.02682 25.7196C3.18038 24.0414 2.01843 21.6019 2.01843 18.8869C2.01843 15.738 3.58174 12.9599 5.96293 11.31C6.79586 10.7067 7.4694 10.4183 8.13863 10.1317C8.65149 9.91201 9.16182 9.69344 9.7394 9.3351C10.6524 8.76863 11.3299 7.93564 11.7085 7.47023C11.7369 7.43522 11.7637 7.40229 11.7888 7.3717L11.7892 7.37396L13.8812 4.52692Z",
    fill: "url(#paint3_radial_713_9347)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8812 4.52692C14.7411 3.28727 16.477 2.82524 17.7291 3.6384C18.9813 4.45155 19.3239 6.0889 18.5108 7.34106L16.8156 9.95134H27.3455C28.8018 9.95134 29.9824 11.132 29.9824 12.5883C29.9824 14.0447 28.8018 15.2253 27.3455 15.2253H23.0614C23.8534 15.6431 24.3932 16.4746 24.3932 17.4323C24.3932 18.523 23.693 19.4501 22.7177 19.7887C23.2295 20.2837 23.5477 20.9777 23.5477 21.746C23.5477 22.8933 22.8381 23.8749 21.8338 24.2759C22.2412 24.7518 22.4872 25.3699 22.4872 26.0454C22.4872 27.5493 21.268 28.7684 19.7642 28.7684H16.6614C16.6267 28.7684 16.5922 28.7677 16.5578 28.7664H11.6987C10.2674 28.7664 7.8208 27.9182 5.67602 26.2566C5.4558 26.0909 5.24326 25.9153 5.03906 25.7304C5.03498 25.7268 5.0309 25.7232 5.02682 25.7196C5.02677 25.7196 5.02688 25.7195 5.02682 25.7196C3.18038 24.0414 2.01843 21.6019 2.01843 18.8869C2.01843 15.738 3.58174 12.9599 5.96293 11.31C6.79586 10.7067 7.4694 10.4183 8.13863 10.1317C8.65149 9.91201 9.16182 9.69344 9.7394 9.3351C10.6524 8.76863 11.3299 7.93564 11.7085 7.47023C11.7369 7.43522 11.7637 7.40229 11.7888 7.3717L11.7892 7.37396L13.8812 4.52692Z",
    fill: "url(#paint4_radial_713_9347)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8812 4.52692C14.7411 3.28727 16.477 2.82524 17.7291 3.6384C18.9813 4.45155 19.3239 6.0889 18.5108 7.34106L16.8156 9.95134H27.3455C28.8018 9.95134 29.9824 11.132 29.9824 12.5883C29.9824 14.0447 28.8018 15.2253 27.3455 15.2253H23.0614C23.8534 15.6431 24.3932 16.4746 24.3932 17.4323C24.3932 18.523 23.693 19.4501 22.7177 19.7887C23.2295 20.2837 23.5477 20.9777 23.5477 21.746C23.5477 22.8933 22.8381 23.8749 21.8338 24.2759C22.2412 24.7518 22.4872 25.3699 22.4872 26.0454C22.4872 27.5493 21.268 28.7684 19.7642 28.7684H16.6614C16.6267 28.7684 16.5922 28.7677 16.5578 28.7664H11.6987C10.2674 28.7664 7.8208 27.9182 5.67602 26.2566C5.4558 26.0909 5.24326 25.9153 5.03906 25.7304C5.03498 25.7268 5.0309 25.7232 5.02682 25.7196C5.02677 25.7196 5.02688 25.7195 5.02682 25.7196C3.18038 24.0414 2.01843 21.6019 2.01843 18.8869C2.01843 15.738 3.58174 12.9599 5.96293 11.31C6.79586 10.7067 7.4694 10.4183 8.13863 10.1317C8.65149 9.91201 9.16182 9.69344 9.7394 9.3351C10.6524 8.76863 11.3299 7.93564 11.7085 7.47023C11.7369 7.43522 11.7637 7.40229 11.7888 7.3717L11.7892 7.37396L13.8812 4.52692Z",
    fill: "url(#paint5_radial_713_9347)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8812 4.52692C14.7411 3.28727 16.477 2.82524 17.7291 3.6384C18.9813 4.45155 19.3239 6.0889 18.5108 7.34106L16.8156 9.95134H27.3455C28.8018 9.95134 29.9824 11.132 29.9824 12.5883C29.9824 14.0447 28.8018 15.2253 27.3455 15.2253H23.0614C23.8534 15.6431 24.3932 16.4746 24.3932 17.4323C24.3932 18.523 23.693 19.4501 22.7177 19.7887C23.2295 20.2837 23.5477 20.9777 23.5477 21.746C23.5477 22.8933 22.8381 23.8749 21.8338 24.2759C22.2412 24.7518 22.4872 25.3699 22.4872 26.0454C22.4872 27.5493 21.268 28.7684 19.7642 28.7684H16.6614C16.6267 28.7684 16.5922 28.7677 16.5578 28.7664H11.6987C10.2674 28.7664 7.8208 27.9182 5.67602 26.2566C5.4558 26.0909 5.24326 25.9153 5.03906 25.7304C5.03498 25.7268 5.0309 25.7232 5.02682 25.7196C5.02677 25.7196 5.02688 25.7195 5.02682 25.7196C3.18038 24.0414 2.01843 21.6019 2.01843 18.8869C2.01843 15.738 3.58174 12.9599 5.96293 11.31C6.79586 10.7067 7.4694 10.4183 8.13863 10.1317C8.65149 9.91201 9.16182 9.69344 9.7394 9.3351C10.6524 8.76863 11.3299 7.93564 11.7085 7.47023C11.7369 7.43522 11.7637 7.40229 11.7888 7.3717L11.7892 7.37396L13.8812 4.52692Z",
    fill: "url(#paint6_radial_713_9347)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14.8643,
    height: 5.27393,
    rx: 2.63697,
    transform: "matrix(-1 0 0 1 29.9824 9.95134)",
    fill: "url(#paint7_linear_713_9347)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14.8643,
    height: 5.27393,
    rx: 2.63697,
    transform: "matrix(-1 0 0 1 29.9824 9.95134)",
    fill: "url(#paint8_linear_713_9347)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7291 3.6384C16.4769 2.82524 14.7411 3.28726 13.8812 4.52691L11.7892 7.37396L11.7888 7.3717C11.7646 7.40111 11.739 7.43268 11.7117 7.46618L11.7084 7.47023C11.3299 7.93564 10.6524 8.76863 9.73938 9.3351C9.31763 9.59677 8.93173 9.78389 8.55454 9.95134H16.8156L18.5107 7.34106C19.3239 6.0889 18.9813 4.45155 17.7291 3.6384Z",
    fill: "url(#paint9_linear_713_9347)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7291 3.6384C16.4769 2.82524 14.7411 3.28726 13.8812 4.52691L11.7892 7.37396L11.7888 7.3717C11.7646 7.40111 11.739 7.43268 11.7117 7.46618L11.7084 7.47023C11.3299 7.93564 10.6524 8.76863 9.73938 9.3351C9.31763 9.59677 8.93173 9.78389 8.55454 9.95134H16.8156L18.5107 7.34106C19.3239 6.0889 18.9813 4.45155 17.7291 3.6384Z",
    fill: "url(#paint10_linear_713_9347)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_713_9347)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3153,
    height: 2.11985,
    rx: 1.05992,
    transform: "matrix(-1 0 0 1 28.0371 10.7962)",
    fill: "url(#paint11_linear_713_9347)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_713_9347)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.12205,
    height: 2.16673,
    rx: 1.08336,
    transform: "matrix(-0.616836 0.787091 0.787091 0.616836 15.959 4.0719)",
    fill: "url(#paint12_linear_713_9347)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_713_9347)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.88453,
    height: 2.65039,
    rx: 1.3252,
    transform: "matrix(-1 0 0 1 23.0703 15.2253)",
    fill: "#FFBE33"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_713_9347)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.88453,
    height: 2.65039,
    rx: 1.3252,
    transform: "matrix(-1 0 0 1 22.5508 19.7847)",
    fill: "#FFBE33"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_713_9347)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.71476,
    height: 2.21069,
    rx: 1.10535,
    transform: "matrix(-1 0 0 1 21.3809 23.9444)",
    fill: "#FFBE33"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3873 17.5957H17.9651V15.2253H23.0608C23.8527 15.6431 24.3926 16.4746 24.3926 17.4323C24.3926 17.4872 24.3908 17.5417 24.3873 17.5957Z",
    fill: "url(#paint13_radial_713_9347)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_713_9347",
    x: 2.01758,
    y: 2.48164,
    width: 27.9648,
    height: 26.2867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.901961 0 0 0 0 0.513726 0 0 0 0 0.258824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_713_9347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_713_9347",
    x: 13.2227,
    y: 9.29617,
    width: 16.3145,
    height: 5.11984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_713_9347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_713_9347",
    x: 9.26953,
    y: 3.00945,
    width: 9.45703,
    height: 10.6413,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_713_9347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_713_9347",
    x: 17.1855,
    y: 14.2253,
    width: 6.88477,
    height: 4.65039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_713_9347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_713_9347",
    x: 16.666,
    y: 18.7847,
    width: 6.88477,
    height: 4.65039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_713_9347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_713_9347",
    x: 16.666,
    y: 22.9444,
    width: 5.71484,
    height: 4.21069,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_713_9347"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_713_9347",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.05776 15.5546) rotate(45.7073) scale(17.4153 25.8784)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9AD28"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_713_9347",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6252 19.2356) rotate(180) scale(6.51954 1.95986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA7C44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763158,
    stopColor: "#DA7C44",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_713_9347",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.3053 24.3152) rotate(-180) scale(7.0795 1.51989)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA7C44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763158,
    stopColor: "#DA7C44",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_713_9347",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.73 19.7899) rotate(-180) scale(2.47656 0.109375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B65B01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B65B01",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_713_9347",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8315 24.2586) rotate(-180) scale(2.375 0.203126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B65B01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B65B01",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_713_9347",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.8948 19.0206) rotate(180) scale(20.3602 23.0505)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.736004,
    stopColor: "#FFEA4A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA4A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_713_9347",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.65964 9.88362) rotate(55.561) scale(2.65239 8.16187)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_713_9347",
    x1: 5.44172,
    y1: 6.21133,
    x2: 5.44172,
    y2: 3.74862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E67B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67B58",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_713_9347",
    x1: 13.9189,
    y1: 5.27393,
    x2: 4.83723,
    y2: 5.27393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBF38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_713_9347",
    x1: 11.8471,
    y1: 6.13362,
    x2: 14.3471,
    y2: 8.50862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE645",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_713_9347",
    x1: 18.1284,
    y1: 9.10237,
    x2: 15.9721,
    y2: 7.75862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79325",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_713_9347",
    x1: 3.79891,
    y1: 2.35759,
    x2: 15.9908,
    y2: 2.35759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD12D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD12D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_713_9347",
    x1: 4.53222,
    y1: 0.0122253,
    x2: 4.76129,
    y2: 2.65697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD12D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD12D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_713_9347",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.7848 14.9159) rotate(20.4027) scale(3.49929 0.792518)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F4709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F4709",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/Pointer.78e8fb9d0387f92f6489bef96e158c67.svg";
export { ForwardRef as ReactComponent };